import Paragraph from '../Paragraph/Paragraph'
import type { LicenseType } from '@eggplant/types'

export interface Props {
  value: LicenseType
}

const licenseName = {
  eAI: 'DAI server',
  ReqT: 'Requirements Traceability',
  UPM: 'User Performance Monitoring'
}

const LicenseTypeLabel = ({
  value
}: Props) =>
  <Paragraph>
    <strong>
      {licenseName[value]}
    </strong>
  </Paragraph>

export default LicenseTypeLabel
